/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-03-18",
    versionChannel: "nightly",
    buildDate: "2025-03-18T00:06:49.710Z",
    commitHash: "36a987e7ca9d2fcea79591b8083f99ab7666af81",
};
